<template>
  <fou-accordion-item
    :id="$vId(this)"
    :class="$style.item"
  >
    <template #heading="headerScope">
      <v-grid
        :in="cols"
        :class="$style.header"
      >
        <v-row style="opacity:1;color:black">
          <v-col has="1">
            <span
              v-if="item.errorLevel"
              :class="[
                $style.arrow,
                'mt-icon',
                `mt-icon-arrow-simple-${headerScope.open ? 'down' : 'right'}`
              ]"
            />
          </v-col>
          <v-col :has="(cols - 2)">
            <div class="out-left">
              {{ item.title }}
            </div>
          </v-col>
          <v-col has="1">
            <error-icon
              v-if="item.errorLevel === 'ERROR'"
              :class="$style.statusIcon"
            />
            <warning-icon
              v-if="item.errorLevel === 'WARN'"
              :class="$style.statusIcon"
            />
            <ok-icon
              v-if="!item.errorLevel"
              :class="$style.statusIcon"
            />
          </v-col>
        </v-row>
      </v-grid>
    </template>
    <template #content>
      <v-grid
        v-if="item.errorLevel"
        :in="cols"
        :class="$style.content"
      >
        <v-row>
          <v-col
            :has="(cols - 2)"
            off="1"
          >
            <div class="out-left out-right">
              <slot name="content" />
            </div>
          </v-col>
        </v-row>
      </v-grid>
    </template>
  </fou-accordion-item>
</template>

<script type="text/ecmascript-6">
import FouAccordionItem from 'components/tools/fou-accordion/item'
import FouGrid from 'components/layout/fou-grid/'
import ErrorIcon from 'components/icons/error/'
import OkIcon from 'components/icons/ok/'
import WarningIcon from 'components/icons/warning/'

export default {
  name: 'ValidationListItem',

  components: {
    ...FouGrid,
    FouAccordionItem,
    ErrorIcon,
    OkIcon,
    WarningIcon
  },

  props: {
    cols: {
      type: [Number,String],
      default: 12
    },
    item: {
      type: Object,
      required: true,
      default: function () {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" module>
@import 'mpl-css/lib/assets/global/functions/index';
@import 'mpl-css/lib/assets/global/variables/colors';
@import 'mpl-css/lib/assets/global/variables/layout';
.header {
  padding: rem($layout-vertical-unit) 0;
  border-bottom: 1px solid map-get($colors, 'grey-light');
}
.item:first-child .header {
  border-top: 1px solid map-get($colors, 'grey-light');
}
.content {
  padding: rem($layout-vertical-unit * 2) 0 rem($layout-vertical-unit * 3);
  background: lighten(map-get($colors, 'grey-light'), 5%);
}
.arrow {
  margin: rem(5) 0 0 rem(10);
}
</style>
